export enum ECultureId {
  WHEAT = 'wheat',
  DURUM = 'wheatDurum',
}
